import { render } from "./PopupModal.vue?vue&type=template&id=3169d6c1"
import script from "./PopupModal.vue?vue&type=script&lang=js"
export * from "./PopupModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ecommunity\\vms-admin.sg\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__